import { useNavigate } from 'react-router-dom';

interface LoginActionsProps {
  className?: string;
}

export function LoginActions({ className = '' }: LoginActionsProps) {
  const navigate = useNavigate();

  const handleSignUp = () => {
    navigate('/signup-select');
  };

  const handleFindAccount = () => {
    navigate('/find-account');
  };

  return (
    <div className={`flex justify-center items-center gap-12 pt-8 ${className}`}>
      <button
        onClick={handleSignUp}
        className="text-[18px] font-medium text-[#222222] border-b-[1.5px] border-[#222222] pb-1 hover:opacity-70 transition-opacity"
      >
        회원가입
      </button>
      <button
        onClick={handleFindAccount}
        className="text-[18px] font-medium text-[#222222] border-b-[1.5px] border-[#222222] pb-1 hover:opacity-70 transition-opacity"
      >
        아이디/비번찾기
      </button>
    </div>
  );
}